import chatMixin from "../../../mixins/chats";
import UserAvatar from '@/components/UserAvatar';

export default {
  name: "Conversation",
  mixins: [
    chatMixin
  ],
  props: {
    selectedConversation: {
      type: Function,
      default: () => {}
    },
    showResultSearch: {
      type: Boolean,
      default: false
    }
  },
  components: {
    UserAvatar
  },
  data() {
    return {
      now: Date.now() / 1000,
      typingTimer: null
    };
  },
  mounted() {
    this.typingTimer = setInterval(() => {
      this.now = Date.now() / 1000;
    }, 2000);
  },
  beforeDestroy() {
    if (this.typingTimer) clearInterval(this.typingTimer);
  },
  computed: {
    typingUser() {
      if (!this.item || !this.item.user_writing) return null;
      for (const uid in this.item.user_writing) {
        if (uid !== this.owner_id && this.item.user_writing[uid] > this.now) {
          const user = this.uxDocs[uid];
          if (user) return user;
        }
      }
      return null;
    },
    last_message() {
      if (!this.item.last_message || !this.item.last_message.type) return '';
      if (this.item.last_message.type === "call") {
        return this.item.last_message.content;
      } else if (this.item.last_message.type === "media") {
        return '#media';
      } else {
        const content = this.item.last_message.content || '';
        return content.replace(/<[^>]*>/g, '').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/\s+/g, ' ').trim();
      }
    }
  },
  methods: {
    selectConversation(item) {
      this.selectedConversation(item);
    }
  }
};
